export const notEmpty = (errorMessage) => (value) =>
  value ? undefined : errorMessage ?? true
